module.exports = __webpack_public_path__ + "c3fdfdc85848d0422f300065b26336fa.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/gcapp.jpg
// module id = 769
// module chunks = 0